module.exports = __webpack_public_path__ + "static/media/wizualizacja-5.80b742e2.png";